export const conversationsConstants = {
    CONVERSATIONS_FETCH: 'CONVERSATIONS_FETCH',
    CONVERSATIONS_SUCCESS: 'CONVERSATIONS_SUCCESS',
    CONVERSATIONS_ERROR: 'CONVERSATIONS_ERROR',
    CONVERSATIONS_LOAD_MORE_SUCCESS: 'CONVERSATIONS_LOAD_MORE_SUCCESS',
    CONVERSATIONS_UPDATE: 'CONVERSATIONS_UPDATE',
    CONVERSATIONS_RESET: 'CONVERSATIONS_RESET',
    CONVERSATIONS_COUNTERS_SUCCESS: 'CONVERSATIONS_COUNTERS_SUCCESS',
    CONVERSATIONS_ARCHIVED_SUCCESS: 'CONVERSATIONS_ARCHIVED_SUCCESS',
};

export const ConversationStatus = {
    Open: 0,
    Closed: 1,
};

export const ConversationMap = {
    Archived: 8,
    Instagram: 6,
    Messenger: 5,
    'WhatsApp Business': 7,
    WhatsApp: 1,
    SMS: 0,
    'Live-chat': 4,
};

export const AssignedStatus = {
    Assigned: 0,
    Unassigned: 1,
    All: 2,
    Mine: 3,
};

export const ConversationActivity = {
    Opened: 0,
    Closed: 1,
    Reassigned: 2,
    Started: 3,
};

export const ConversationSorting = {
    ActivityNewestFirst: 0,
    ActivityOldestFirst: 1,
    CreatedAtNewestFirst: 2,
    CreatedAtOldestFirst: 3,
};

export const ConversationProperty = {
    Status: 0,
};
